import React from 'react'
import PropTypes from 'prop-types'
import { graphql, Link } from 'gatsby'
import redShirt from '../img/children/boy-red-shirt.svg'
// import blackHair from '../img/children/girl-black-hair.svg'
// import yellowShirt from '../img/children/boy-yellow-shirt.svg'
import dp from '../img/boards/dp.png'
import rmhs from '../img/boards/rmhs.png'
import ddrc from '../img/boards/ddrc.png'
import nmcs from '../img/boards/nmcs.jpg'

import Layout from '../components/Layout'
import CrayonList from '../components/CrayonList'
// import BlogRoll from '../components/BlogRoll'

export const IndexPageTemplate = ({
  image,
  title,
  heading,
  subheading,
  mainpitch,
  services,
  rates,
  description,
  intro,
}) => (
  <div>
    <section className="section section--gradient">
      <div className="container">
        <div className="section">
          <div className="columns is-centered">
            <div className="column is-two-thirds">
              <div className="content has-text-centered">
                <br />
                <h1>Peek-a-boo Pediatric Therapy LLC</h1>
                <h2>Occupational therapy services to children birth to 3 years old and their families in the Denver-metro area</h2>
                <div class="field is-grouped is-justify-content-center">
                  <p class="control">
                    <button className="button is-secondary">
                      <Link
                        className="title has-text-primary is-size-4"
                        to="/courses"
                      >
                        Courses
                      </Link>
                    </button>
                  </p>
                  <p class="control">
                    <button className="button is-secondary">
                      <Link
                        className="title has-text-primary is-size-4"
                        to="/blog"
                      >
                        Blog
                      </Link>
                    </button>
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
    <div class="relative-container">
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1440 320"><path fill="#bde5ff" fill-opacity="1" d="M0,128L48,117.3C96,107,192,85,288,80C384,75,480,85,576,128C672,171,768,245,864,266.7C960,288,1056,256,1152,213.3C1248,171,1344,117,1392,90.7L1440,64L1440,320L1392,320C1344,320,1248,320,1152,320C1056,320,960,320,864,320C768,320,672,320,576,320C480,320,384,320,288,320C192,320,96,320,48,320L0,320Z"></path></svg>
      <div class="behind-container">
        <img src={redShirt} alt="Child" className="child red-shirt" />
      </div>
    </div>
    {/* end mainpitch */}
    {/* start services */}
    <section className="section section--gradient blue-background">
      <div className="container">
        <div className="section">
          <div className="columns">
            <div className="column">
              <div className="content">
                <div className="box">
                  <h3>Our therapists are experts in all aspects of your child's development.</h3>
                  {/* <h4>We provide services in environments where your child experiences the most; your home, your daycare or in the community.</h4>
                  <h4>We are named Peek-a-boo Pediatric Therapy because every child should have the opportunity to play the game of peek-a-boo with their parents, siblings, grandparents and any other person in their life.</h4> */}
                  <br />
                  <h4>We look at the child in how they:</h4>
                  <ul>
                    <li>
                      <p>manage their body when happy, upset, nervous, etc.</p>
                    </li>
                    <li>
                      <p>interact and react to different sensory experiences such as touch, taste, smell, sound, and what they look at.</p>
                    </li>
                    <li>
                      <p>interpret how they move and understanding the components needed to play with toys and their caregivers.</p>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
          <div className="columns">
            <div className="column">
              <div className="content">
                <div className="box">
                  <h4>We are trained in:</h4>
                  <CrayonList treatments={[
                    'interoception',
                    'regulation',
                    'sensory processing',
                    'motor skills',
                    'play',
                    'social skills',
                    'speech and language',
                    'feeding',
                    'visual impairments',
                    'hearing impairments',
                    'assistive technology',
                    'movement and handling',
                    'trauma and attachment'
                  ]} />
                </div>
                <div className="box has-text-centered">
                  <h4>All to help with common childhood diagnosis, such as:</h4>
                  <p>Sensory processing dysfunction • Developmental delays • Fine motor delays • Gross motor delays • Clumsy/discoordinated • Autism • Cerebral Palsy • Childhood syndromes • Neurological conditions • Prematurity • Orthopedic conditions • Hyperactivity • Learning disability • Feeding delays • Trauma • And more</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
    <div class="relative-container blue-background">
      {/* <div class="front-container">
        <img src={blackHair} alt="Child" className="child black-hair" />
      </div> */}
      <svg id="waves-black-hair" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1440 320">
        <path fill="#ffffff" fill-opacity="1" d="M0,32L60,42.7C120,53,240,75,360,117.3C480,160,600,224,720,208C840,192,960,96,1080,69.3C1200,43,1320,85,1380,106.7L1440,128L1440,320L1380,320C1320,320,1200,320,1080,320C960,320,840,320,720,320C600,320,480,320,360,320C240,320,120,320,60,320L0,320Z"></path>
      </svg>
    </div>
    {/* end services */}
    {/* start rates */}
    <section className="section section--gradient">
      <div className="container rates-container">
        <div className="section">
          <div className="content">
            <h1>Our Rates</h1>
            <h3 className="subtitle">We contract with the following community center boards:</h3>
          </div>
          <div className="columns">
            <div className="column">
              <figure class="image box">
                <img src={dp} alt="DP" className="board-image" />
              </figure>
            </div>
            <div className="column">
              <figure class="image box">
                <img src={rmhs} alt="RMHS" className="board-image" />
              </figure>
            </div>
          </div>
          <div className="columns">
            <div className="column">
              <figure class="image box">
                <img src={ddrc} alt="DDRC" className="board-image" />
              </figure>
            </div>
            <div className="column">
              <figure class="image box">
                <img src={nmcs} alt="NMCS" className="board-image" />
              </figure>
            </div>
          </div>
          <div className="columns is-centered">
            <div className="column is-two-thirds">
              <div className="box blue-background has-text-centered">
                <div className="content">
                  <p>
                    Early intervention is a state run program for children who have minimal to moderate/severe delays in one or more areas of development. To see if your child qualifies, you can call your local community center board intake coordinator to set up an initial evaluation. This is a no-cost to family program and in doing so, they will attempt to bill insurance and medicaid. You will not have to worry about your deductible or co-pays through this program.
                    <br />
                    <br />
                    If you wish to not go through the Early Intervention program we offer private pay rates.
                    Please contact us for more information.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
    <div class="relative-container">
      {/* <div class="behind-container">
        <img src={yellowShirt} alt="Child" className="child yellow-shirt" />
      </div> */}

    </div>
    {/* <section className="section section--gradient">
      <div className="container">
        <div className="section">
          <div className="columns">
            <div className="column is-12">
              <h3 className="has-text-weight-semibold is-size-2">
                Blog
              </h3>
              <BlogRoll />
            </div>
          </div>
        </div>
      </div>
    </section> */}
  </div >
)

IndexPageTemplate.propTypes = {
  image: PropTypes.oneOfType([PropTypes.object, PropTypes.string]),
  title: PropTypes.string,
  heading: PropTypes.string,
  subheading: PropTypes.string,
  mainpitch: PropTypes.object,
  description: PropTypes.string
}

const IndexPage = ({ data }) => {
  const { frontmatter } = data.markdownRemark

  return (
    <Layout>
      <IndexPageTemplate
        image={frontmatter.image}
        title={frontmatter.title}
        heading={frontmatter.heading}
        subheading={frontmatter.subheading}
        mainpitch={frontmatter.mainpitch}
        services={frontmatter.services}
        description={frontmatter.description}
        intro={frontmatter.intro}
        rates={frontmatter.rates}
      />
    </Layout>
  )
}

IndexPage.propTypes = {
  data: PropTypes.shape({
    markdownRemark: PropTypes.shape({
      frontmatter: PropTypes.object,
    }),
  }),
}

export default IndexPage

export const pageQuery = graphql`
  query IndexPageTemplate {
        markdownRemark(frontmatter: {templateKey: {eq: "index-page" } }) {
        frontmatter {
        title
        image {
        childImageSharp {
        fluid(maxWidth: 2048, quality: 100) {
        ...GatsbyImageSharpFluid
      }
          }
        }
        heading
        subheading
        mainpitch {
        heading
          line1
          line2
          line3
        }
        services {
        heading
          subheading
          intro
          list
        }
        rates {
        heading
          ei
          subheading
        }
        description
        intro {
        heading
          description
        }
      }
    }
  }
`
